export default {
  'diagnostics.list.header.customer': 'Cliente',
  'diagnostics.list.header.creation': 'Data de criação',
  'diagnostics.list.header.entryDate': 'Data de entrada',
  'diagnostics.list.header.plate': 'Placa',
  'diagnostics.list.newDiagnostics': 'Novo diagnóstico',
  'diagnostics.form.company': 'Empresa',
  'diagnostics.form.vehicle.title': 'Veículo do cliente',
  'diagnostics.form.vehicle.description':
    'Clique em buscar para pesquisar um cliente',
  'diagnostics.form.obs': 'Relato do cliente',
  'diagnostics.form.partsList': 'Lista de Peças',
  'diagnostics.form.partsList.status.ok': 'Ok',
  'diagnostics.form.partsList.status.replace': 'Substituir',
  'diagnostics.form.partsList.status.repair': 'Reparar',
  'diagnostics.form.partsList.header.description': 'Descrição',
  'diagnostics.form.partsList.header.status': 'Situação',

  'diagnostics.form.notification.success.title':
    'Diagnóstico criado com sucesso!',
  'diagnostics.form.notification.success.description':
    'O diágnóstico foi salvo com sucesso no sistema.',

  'diagnostics.form.notification.error.title':
    'Ocorreu um erro ao salvar o diagnóstico!',
  'diagnostics.form.notification.error.description':
    'Verifique os campos e tente novamente',

  'diagnostics.remove.notification.success.title':
    'Diagnóstico excluido com sucesso',
  'diagnostics.remove.notification.success.description':
    'O diagnótico foi excluído com sucesso.',

  'diagnostics.remove.notification.error.title':
    'Erro ao excluir o diagnóstico!',
  'diagnostics.remove.notification.error.description':
    'Ocorreu um erro ao excluir o diagnótico.',

  'diagnostics.update.notification.success.title':
    'Diagnóstico atualizado com sucesso',
  'diagnostics.update.notification.success.description':
    'O diagnótico foi atualizado com sucesso.',

  'diagnostics.update.notification.error.title':
    'Erro ao atualizar o diagnóstico!',
  'diagnostics.update.notification.error.description':
    'Ocorreu um erro ao atualizar o diagnótico.',

  'diagnostics.modal.title': 'Buscar veículo',
  'diagnostics.modal.button.select': 'Selecionar',
  'diagnostics.modal.steps.selectCustomer': 'Selecionar cliente',
  'diagnostics.modal.steps.selectVehicle': 'Selecionar veículo',
  'diagnostics.modal.vehicles.licensePlate': 'Placa',
  'diagnostics.modal.vehicles.description': 'Detalhes',
  'diagnostics.modal.remove.title': 'Excluir diagnóstico',
  'diagnostics.modal.remove.content':
    'Deseja realmente excluir esse diagnótico?',

  'diagnostics.form.vehicle': 'Veículo',
  'diagnostics.form.vehicle.customer': 'Cliente',
  'diagnostics.form.vehicle.plate': 'Placa',

  'diagnostics.modal.report.title': 'Relatório do diagnóstico',
  'diagnostics.modal.report.error.title': 'Erro ao gerar o relatório',
  'diagnostics.modal.report.error.description':
    'Ocorreu um erro ao gerar o relatório.',

  'diagnostics.modal.generateBudget.title': 'Gerar orçamento',
  'diagnostics.modal.generateBudget.btn.generateBudget': 'Gerar orçamento',
  'diagnostics.modal.generateBudget.btn.close': 'Fechar',
  'diagnostics.modal.generateBudget.checkbox.demand': 'Cobrar Diagnóstico?',
  'diagnostics.modal.generateBudget.checkbox.include':
    'Incluir peça no Orçamento',
};
